<script>
export default {
  props: {
    // The text to display in the tooltip
    text: {
      type: String,
      requred: true,
    },
  },
};
</script>

<template>
  <span
    class="InfoTooltip-icon"
    v-b-tooltip.hover="{ customClass: 'InfoTooltip-tooltip' }"
    :title="text"
  >
    <font-awesome-icon icon="info-circle" />
  </span>
</template>

<style>
.InfoTooltip-icon {
  display: inline-block;
  color: rgba(0, 0, 0, 0.45);
  padding: 0.12rem 0.5rem;
  margin: 0 -0.5rem;
  height: 24px;
}
</style>
